import React from 'react';
import { motion } from 'framer-motion';
import { Video, MessageSquare, PlayCircle, Zap, BookOpen, Users } from 'lucide-react';
const features = [{
  icon: Video,
  text: '2 mentorías en vivo por semana vía Zoom'
}, {
  icon: MessageSquare,
  text: 'Grupo privado de WhatsApp'
}, {
  icon: PlayCircle,
  text: 'Grabaciones de todas las sesiones'
}, {
  icon: Zap,
  text: 'Ejercicios prácticos semanales'
}, {
  icon: BookOpen,
  text: 'Auto-consejos semanales de disciplina'
}, {
  icon: Users,
  text: 'Comunidad enfocada en ejecución'
}];
export function IncludesSection() {
  return <section className="py-24 bg-[#111]" data-id="element-125">
      <div className="container mx-auto px-4" data-id="element-126">
        <div className="text-center mb-16" data-id="element-127">
          <h2 className="text-4xl md:text-5xl font-['Bebas_Neue'] text-white" data-id="element-128">
            QUÉ INCLUYE
          </h2>
          <div className="w-16 h-1 bg-[#C9A84C] mx-auto mt-4" data-id="element-129" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-130">
          {features.map((feature, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex items-center gap-6 p-6 bg-[#0a0a0a] border border-white/5 hover:border-[#C9A84C]/50 transition-colors group rounded-sm" data-id="element-131">
              <div className="p-3 bg-[#C9A84C]/10 rounded-full group-hover:bg-[#C9A84C] transition-colors duration-300" data-id="element-132">
                <feature.icon className="w-6 h-6 text-[#C9A84C] group-hover:text-black transition-colors duration-300" data-id="element-133" />
              </div>
              <span className="text-lg text-gray-300 font-medium group-hover:text-white transition-colors" data-id="element-134">
                {feature.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}